import { useEffect } from 'react';
import { tokenService } from '../services/tokenService';

export const useRequireAuth = (): void => {
  useEffect(() => {
    const token = tokenService.getToken();
    if (!token) {
      const returnTo = encodeURIComponent(window.location.pathname + window.location.search);
      window.location.href = `/login?returnTo=${returnTo}`;
    }
  }, []);
};